<template>
    <div class="ecomin">
      <div>
        <div class="tp1">
            <div> 
              <b-img :src="require('@/assets/banner03new_720.png')" class="tp1-image" />
            </div>             
        </div>
        <div class="tp2">
            <div class="tp2_txt1">
              <div class="tp2_txt1_title">
                <div class="txt1_title">
                Through our ecosystem, achieve more effective management and control<br> of diabetes, and improve the quality of life for patients
                </div>
              </div>
              <div class="tp2_txt1_sub">Diabetes is not only increasing dramatically in numbers, but the health and economic burdens it brings are also continuously intensifying,<br> requiring a global collective effort to address this challenge. Various aspects and participants related to diabetes management, including<br> doctors, caregivers, family and friends, and partners, are all components of the ecosystem.<br> We integrate and share in-hospital and out-patient data information into an ecosystem to provide more comprehensive medical services<br> and health management. This helps to improve the continuity and efficiency of medical services, while also providing patients with a more<br> personalized medical experience.</div>
            </div>
            <div class="tp2_image">
              <b-img :src="require('@/assets/econew1.png')" fluid alt="Responsive image" class="tp2_i1" />
            </div>        
        </div>
        <div class="tp3">
          <div class="tp3_title">Ecosystem Functional Characteristics</div>
        </div>

        <div class="tp4">
          <div class="tp4_left"></div>
          <div class="tp4_mid">
            <div class="tp4_mid_1">
              <div class="tp4_mid_1_image"><b-img :src="require('@/assets/ecop3.svg')" class="tp3icon1" /></div>
              <div class="tp4_mid_1_title">Interconnection</div>
              <div class="tp4_mid_1_sub">Seamlessly connect and communicate all devices, products, and components of the ecosystem to achieve information sharing</div>
            </div>
            <div class="tp4_mid_2">
              <div class="tp4_mid_2_image"><b-img :src="require('@/assets/ecop5.svg')" class="tp3icon2" /></div>
              <div class="tp4_mid_2_title">Patient-Centered</div>
              <div class="tp4_mid_2_sub">The system is centered on the needs and experiences of patients, providing personalized medical services</div>
            </div>
            <div class="tp4_mid_3">
              <div class="tp4_mid_3_image"><b-img :src="require('@/assets/ecop3.svg')" class="tp3icon3" /></div>
              <div class="tp4_mid_3_title">Collaboration</div>
              <div class="tp4_mid_3_sub">Different healthcare professionals and organizations collaborate to provide comprehensive services to patients</div>
            </div>
            <div class="tp4_mid_4">
              <div class="tp4_mid_4_image"><b-img :src="require('@/assets/ecop4.svg')" class="tp3icon4" /></div>
              <div class="tp4_mid_4_title">Continuous Evolution</div>
              <div class="tp4_mid_4_sub">With the advancement of medical knowledge and technology, the ecosystem continuously evolves and improves</div>
            </div>
          </div>
          <div class="tp4_right"></div>
        </div>
        
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'EcosystemPage'
  }
  </script>
  
  <style scoped>
  .ecomin{
    min-width: 1200px;
  }
  
  .tp1 {
    position: relative;
  width: 100%;
  overflow: hidden;
  }

  .tp1-image{
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; /* 使图片按比例填满容器 */
  }

.tp2{
  text-align: center;
  background: linear-gradient(90deg, #D6E9FF 0%, #F4F8FF 47.5%, #D6E9FF 100%);
  ;
}
.tp2_txt1_title{
  font-family: Arial;
font-size: 24px;
font-weight: 400;
line-height: 34px;
text-align: center;
padding-top: 59px;
}
.tp2_txt1_sub{
  margin-top: 24px;
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
color: #1B2944;
}

.tp2_i1{
width: 1200px;
height: 628px;
}
.tp2-container{
    padding: 0;
    width: 100%;
}
.imgdescription2{
    position: relative;
    top: 30px;
    width: 984px;
}
.imgdescription2 h1{
    font-family: Inter;
    font-size: 24px;
    font-weight: 400;
    line-height: 34px;
    text-align: center;
}
.imgdescription2 h2{
    font-family: Source Sans 3;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
    text-align: center;

}
.tp2-image{
    height: 912px;
    object-fit: cover;

    width: 100%;
    padding-bottom: 0px;
}
.button-style {
    display: block;
    margin: 20px auto;
    background-color: #007bff;
    color: white;
}

.footer {
  background-color: #f8f9fa;
  padding: 0px 0;
  margin-top: 123px;
}

.footer-links {
  display: flex;
  justify-content: space-around; /* 链接均匀分布 */
  flex-wrap: wrap; /* 当屏幕较小时，链接会换行 */
  padding: 0;
  list-style-type: none;
}

.footer-links a {
  text-decoration: none;
  color: #007bff;
  margin: 0 10px; /* 添加左右间距 */
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-description {
  text-align: center;
}

.footer-line {
  border: 1px solid #dee2e6;
  margin: 20px 0;
}

.footer-description p {
  margin-top: 10px;
  color: #6c757d;
}
.footertxt{
    background-color: #F4F7FC;
    padding: 30px;
    padding-top: 100px;
  }
.t3{
    text-align: center;
    padding-top: 50px;
}
.t3c1d h1{
    font-family: Source Sans 3;
font-size: 16px;
font-weight: 400;
line-height: 24px;
}
.t3c1d h2{
    font-family: Source Sans 3;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
}

.t3c2d h1{
    font-family: Source Sans 3;
font-size: 16px;
font-weight: 400;
line-height: 24px;
}
.t3c2d h2{
    font-family: Source Sans 3;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
}
.t3c3d h1{
    font-family: Source Sans 3;
font-size: 16px;
font-weight: 400;
line-height: 24px;
}
.t3c3d h2{
    font-family: Source Sans 3;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
}
.t3c4d h1{
    font-family: Source Sans 3;
font-size: 16px;
font-weight: 400;
line-height: 24px;
}
.t3c4d h2{
    font-family: Source Sans 3;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
}
.tp3-container{
    text-align: center;
    padding-top: 50px;
}
.tp3{
  
}
.tp3_txt{
  display: flex;
  margin-top: 24px;
  margin-left: 18.75%;
}
.tp3_txt_1{

}
.tp3_title{
  font-family: Arial;
font-size: 36px;
font-weight: 700;
line-height: 44px;
color: #000000;
margin-top: 54px;
text-align: center;
}

.tp4 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
}

.tp4_left,
.tp4_right {

}

.tp4_mid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 将中间部分均等划分为四列 */
  gap: 20px; /* 设置每列之间的间距 */
}

.tp4_mid_1,
.tp4_mid_2,
.tp4_mid_3,
.tp4_mid_4 {
  padding: 20px; /* 添加内边距 */
  display: flex;
  flex-direction: column;
  align-items: center; /* 子元素在垂直方向上居中 */
  justify-content: flex-start; /* 子元素在水平方向上对齐起始位置 */
}

.tp4_mid_1_image,
.tp4_mid_2_image,
.tp4_mid_3_image,
.tp4_mid_4_image {
  display: flex;
  justify-content: center; /* 水平方向居中 */
  align-items: center; /* 垂直方向居中 */
  width: 100%; /* 确保容器宽度为100% */
}

.tp3icon1,
.tp3icon2,
.tp3icon3,
.tp3icon4 {
  width: 56px; /* 图像宽度 */
  height: auto;
}

.tp4_mid_1_title,
.tp4_mid_2_title,
.tp4_mid_3_title,
.tp4_mid_4_title {
  font-family: Arial;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #333333;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
}

.tp4_mid_1_sub,
.tp4_mid_2_sub,
.tp4_mid_3_sub,
.tp4_mid_4_sub {
  display: flex;
  align-items: center;

  width: 100%; /* 确保容器宽度为100% */
  text-align: left; /* 内容靠左对齐 */
  flex-direction: column; /* 垂直排布 */
  color: #555555;
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;


}
  </style>